import { useEffect, useState } from 'react'
import { section7Data } from './data/section7Data'
import { UserMarketingSlide } from './UserMarketingSlide'
import { useSwipeable } from 'react-swipeable'

export const Section7 = () => {
  const [active, setActive] = useState(0)
  const [slideWidth, setSlideWidth] = useState(869) // Default width

  const handleSetActive = (idx: number) => {
    if (idx >= 0 && idx < section7Data.length) {
      setActive(idx)
    }
  }

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleSetActive(active + 1),
    onSwipedRight: () => handleSetActive(active - 1),
    preventScrollOnSwipe: true,
    trackTouch: true,
  })

  // Update slide width based on screen size
  useEffect(() => {
    const updateSlideWidth = () => {
      if (window.innerWidth >= 768) {
        setSlideWidth(window.innerWidth) // Use 100vw (full screen width) at lg+ breakpoint
      } else {
        setSlideWidth(869) // Use 869px for smaller screens
      }
    }
    updateSlideWidth()
    window.addEventListener('resize', updateSlideWidth)
    return () => window.removeEventListener('resize', updateSlideWidth)
  }, [])

  return (
    <div
      {...swipeHandlers}
      className='py-20 h-[1108px] lg:h-[800px] xl:h-[900px] bg-[linear-gradient(0deg,_rgba(235,243,255,1)_0%,_rgba(255,255,255,1)_100%)] flex flex-col overflow-hidden 2xl:h-[1000px] 3xl:h-[1100px]'
    >
      {/* Large container for all slides */}
      <div
        className='flex transition-transform duration-500 ease-in-out w-[2607px] lg:w-[300vw]'
        style={{ transform: `translateX(-${active * slideWidth}px)` }} // Translate based on active slide
      >
        {section7Data.map((slide, idx) => (
          <div key={idx} className='w-[869px] md:w-[100vw]'>
            <UserMarketingSlide {...slide} />
          </div>
        ))}
      </div>
      <div className='flex justify-center gap-4 pt-6 lg:justify-end lg:mr-20 lg:pt-0'>
        {section7Data.map((_, idx) => (
          <button
            key={idx}
            aria-label={`Go to slide ${idx + 1}`}
            onClick={() => handleSetActive(idx)}
            className={`h-2 rounded-full bg-[#001A3D] first-letter:transition-all focus:outline-none ${active === idx
              ? 'w-8'
              : 'w-2'
              }`}
            type='button'
          />
        ))}
      </div>
    </div>
  )
}
